import React, { useState } from "react";
import {
 Box,
 Button,
 Heading,
 VStack,
 Text,
 SimpleGrid,
 useBreakpointValue,
} from "@chakra-ui/react";
import { allCollegeData } from "../collegesData";
import CollegeList from "./ListingPage";

const countryList = [
 "Nepal",
 "Bangladesh",
 "Russia",
 "Kyrgystan",
 "Georgia",
 "Kazakhstan",
 "Uzbekistan",
 "Egypt",
 "Italy",
];

const AbroadListingPage = () => {
 const [selectedCountry, setSelectedCountry] = useState(null);

 // Adjust column count based on screen size
 const columns = useBreakpointValue({ base: 2, sm: 3, md: 4, lg: 5 });

 return (
  <Box py={10} px={[4, 6, 8]} bg="gray.50" minH="100vh">
   <Heading mb={8} textAlign="center" fontSize={["1.8rem", "2.5rem"]}>
    MBBS in Abroad
   </Heading>

   <SimpleGrid columns={columns} spacing={4} mb={10} justifyItems="center">
    {countryList.map((country) => (
     <Button
      key={country}
      variant={selectedCountry === country ? "solid" : "outline"}
      colorScheme="blue"
      onClick={() => setSelectedCountry(country)}
      width="100%"
      fontWeight="600"
      borderRadius="xl"
     >
      {country}
     </Button>
    ))}
   </SimpleGrid>

   {selectedCountry && (
    <Box mt={6}>
     <Text fontSize={["lg", "xl"]} fontWeight="bold" mb={4} textAlign="center">
      Colleges in {selectedCountry}
     </Text>
     <CollegeList collegeData={allCollegeData[selectedCountry] || []} />
    </Box>
   )}
  </Box>
 );
};

export default AbroadListingPage;
